/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Africa_DescriptionInputs */

const bn_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি সম্পূর্ণ আঞ্চলিক পুলে প্রতিটি আফ্রিকান দেশ।`)
};

const de_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes afrikanische Land in einem vollständigen regionalen Pool.`)
};

const el_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάθε αφρικανική χώρα σε μια πλήρη περιφερειακή πισίνα.`)
};

const en_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every African country in one complete regional pool.`)
};

const es_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los países africanos en un grupo regional completo.`)
};

const fr_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les pays d’Afrique dans un pool régional complet.`)
};

const hi_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक अफ़्रीकी देश एक पूर्ण क्षेत्रीय पूल में।`)
};

const hu_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden afrikai ország egy teljes regionális medencében.`)
};

const id_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap negara Afrika dalam satu kelompok regional yang lengkap.`)
};

const it_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i paesi africani in un pool regionale completo.`)
};

const ja_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフリカのすべての国が 1 つの完全な地域プールに含まれています。`)
};

const ko_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 아프리카 국가가 하나의 완전한 지역 풀에 있습니다.`)
};

const nl_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk Afrikaans land in één complete regionale poule.`)
};

const pl_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy kraj afrykański w jednej kompletnej puli regionalnej.`)
};

const pt_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada país africano num grupo regional completo.`)
};

const ru_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждая африканская страна в одном полном региональном пуле.`)
};

const sv_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje afrikanskt land i en komplett regional pool.`)
};

const tr_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her Afrika ülkesi tek bir bölgesel havuzda.`)
};

const uk_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кожна африканська країна в одному повному регіональному пулі.`)
};

const vi_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi quốc gia châu Phi nằm trong một nhóm khu vực hoàn chỉnh.`)
};

const zh_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个非洲国家都在一个完整的区域池中。`)
};

const zh_hant_intro_region_africa_description = /** @type {(inputs: Intro_Region_Africa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每個非洲國家都在一個完整的區域池中。`)
};

/**
* | output |
* | --- |
* | "Every African country in one complete regional pool." |
*
* @param {Intro_Region_Africa_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_africa_description = /** @type {((inputs?: Intro_Region_Africa_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Africa_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_africa_description(inputs)
	if (locale === "de") return de_intro_region_africa_description(inputs)
	if (locale === "el") return el_intro_region_africa_description(inputs)
	if (locale === "en") return en_intro_region_africa_description(inputs)
	if (locale === "es") return es_intro_region_africa_description(inputs)
	if (locale === "fr") return fr_intro_region_africa_description(inputs)
	if (locale === "hi") return hi_intro_region_africa_description(inputs)
	if (locale === "hu") return hu_intro_region_africa_description(inputs)
	if (locale === "id") return id_intro_region_africa_description(inputs)
	if (locale === "it") return it_intro_region_africa_description(inputs)
	if (locale === "ja") return ja_intro_region_africa_description(inputs)
	if (locale === "ko") return ko_intro_region_africa_description(inputs)
	if (locale === "nl") return nl_intro_region_africa_description(inputs)
	if (locale === "pl") return pl_intro_region_africa_description(inputs)
	if (locale === "pt") return pt_intro_region_africa_description(inputs)
	if (locale === "ru") return ru_intro_region_africa_description(inputs)
	if (locale === "sv") return sv_intro_region_africa_description(inputs)
	if (locale === "tr") return tr_intro_region_africa_description(inputs)
	if (locale === "uk") return uk_intro_region_africa_description(inputs)
	if (locale === "vi") return vi_intro_region_africa_description(inputs)
	if (locale === "zh") return zh_intro_region_africa_description(inputs)
	return zh_hant_intro_region_africa_description(inputs)
});